module.exports = "pegasus/assets/theme5/small/5.jpg";